import styled from 'styled-components';

const colorTheme = {
  blue: '#1b7bdd',
  red: '#ce445b',
  green: '#1ba39c',
};

export const PaddingBar = styled.div`
  width: 100%;

  @media (min-width: 992px) {
    padding-bottom: 45px;
  }
`;

export const SocialMediaContainer = styled.div`
  @media (min-width: 992px) {
    padding-top: 5px;
  }
`;
export const ShareIconButton = styled.div`
  background-image: url(/svg/sprites.svg#shareblack);
  @media (max-width: 991.98px) {
    background-image: url(/svg/sprites.svg#sharewhite);
  }
`;

export const ShareIconWrapper = styled.div`
  width: 35px;
  height: 36px;
  border-radius: 50%;
  transition: none;
  z-index: 9;
  position: absolute;
  right: ${({ dir }) => (dir === 'rtl' ? '' : '0px')};
  left: ${({ dir }) => (dir === 'rtl' ? '0px' : '')};
  top: -3.6rem;
  background: transparent;

  @media (min-width: 992px) {
    background: #fff;
    right: ${({ dir }) => (dir === 'rtl' ? '' : '0px')};
    left: ${({ dir }) => (dir === 'rtl' ? '0px' : '')};
    top: 2.6rem;
  }
  @media (max-width: 991px) {
    z-index: 9;
  }

  @keyframes appear {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .share-arrow {
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.2s linear;
    opacity: 0;
    cursor: pointer;
  }

  .share {
    cursor: pointer;
    fill: #fff;
    border-radius: 50%;
    transition: all 0.2s linear;

    @media (min-width: 992px) {
      fill: #000;
    }
  }

  &:hover {
    .share {
      cursor: pointer;
      fill: transparent;
      stroke: transparent;
      color: transparent;
      border-radius: 50%;
      background-color: ${({ color }) => colorTheme[color]};
    }
    .share-arrow {
      opacity: 1;
    }
  }

  .socialIconsContainer {
    display: none;
  }

  &:hover {
    .socialIconsContainer {
      display: flex;
    }

    .facebook,
    .twitter,
    .linkedin {
      animation-name: appear;
      animation-duration: 300ms;
      animation-timing-function: linear;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
    }

    .facebook {
      background-color: #3c579e;
      animation-delay: 125ms;
    }

    .twitter {
      background-color: #0076b4;
      animation-delay: 200ms;
    }

    .linkedin {
      background-color: #0e78e0;
      animation-delay: 50ms;
    }
  }

  & > .first {
    height: 100%;
    cursor: pointer;
    border-radius: 50%;

    @media (max-width: 991px) {
      fill: #fff;
    }
  }

  &:hover {
    & > .first {
      background-image: url(/svg/sprites.svg#shareblue);
      background-color: ${({ color }) => colorTheme[color]};
      color: #fff;
      fill: #fff;
      path {
        &:first-child {
          fill: ${({ color }) => colorTheme[color]};
        }
      }
    }

    & > .second {
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
    }
  }

  & > .second {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: transparent;
    background-color: transparent;
  }
`;

export const SocialIconsContainer = styled.div`
  border-top: solid 0.5rem transparent;
  height: auto;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-evenly;

  .twitter-x {
    background-color: #000 !important;
    fill: #fff !important;
    padding: 5px;
  }

  .icon {
    width: 35px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    opacity: 0;
    transform: scale(0);
    margin-bottom: 5px;

    &:hover {
      &:after {
        content: '';
        height: 2.5rem;
        width: 2.5rem;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 10;
      }
    }
  }
`;

export const ShareIconHead = styled.div`
  position: relative;
`;
